import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import Post from "./Post";
import Edit from "./Edit";
import {RouterProps} from "../../RouterProps";

export default function TargetRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:contentTargetId'} element={<Detail {...props} />} />
            <Route path={'/:contentTargetId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}